import React, {useEffect, useState, Fragment} from 'react';

import SpinnerDiv from "ui/SpinnerDiv";
import ProgressReviewTermTable from "./ReactProgressReviewTermTable";

import useModalGenerateReviews from "../Modals/useModalGenerateReviews";

const ProgressReviewSchedulingPage = ( props ) =>
{
	const [ data, setData ] = useState ( { loading: true, yeardata: [] });

	const [ renderModal, showModal ] = useModalGenerateReviews() ;

	useEffect(() => {
		getData();
	}, []);

	const getData = () =>
	{
    	$.ajax({
    		  type: 'GET',
    		  url: Globals.APIFolder + '/outcomes/year/status',
    		  success:(data)=>{
  
  				if ( checkError ( data ))
				{
					const yeardata = data.data;

					setData ( {yeardata: yeardata[0], loading: false}) ;
				}      						
				else
				{
					location.assign ( 'home.php' ) ;
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>{

    			  handleAjaxError(jqXHR, textStatus, error) ;
      		  }
    		});
	}

    const renderedComponent = () =>
	{
		let str = 'Today is within the academic year ' + data.yeardata.current_academic_year_from  + '-' ;
		str += data.yeardata.current_academic_year_to ;

		return (
			<div key='PRTablePanel' className='panel panel-default panel-base'>
				<div key='AcademicYearDiv' style={{paddingBottom: '10px'}}>{str}</div>
				<ProgressReviewTermTable key={'PrTable'} clickHandler={showModal} />
				<div key='textdivs'>
					<div key='text1' style={{paddingBottom: '10px'}}>This table shows the terms for which requests have already been sent.</div>
					<div key='text2' style={{paddingBottom: '10px'}}>To send requests out for another term, click the green icon.</div>
				</div>
				{renderModal(props)}
			</div>
		)
	}
	
	return data.loading === true ? <SpinnerDiv/> :
		<div className="jumbotron">
			<p className="med">Progress Review Scheduling</p>
			{renderedComponent()}
		</div>

}

export default ProgressReviewSchedulingPage;

